// Auto-generated file

import { lazy } from "react";

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  "email-identifier-challenge": lazy(
    () => import("@/screens/email-identifier-challenge")
  ),
  "email-verification-result": lazy(
    () => import("@/screens/email-verification-result")
  ),
  "login-id": lazy(() => import("@/screens/login-id")),
  "login-password": lazy(() => import("@/screens/login-password")),
  "login-passwordless-email-code": lazy(
    () => import("@/screens/login-passwordless-email-code")
  ),
  "mfa-begin-enroll-options": lazy(
    () => import("@/screens/mfa-begin-enroll-options")
  ),
  "mfa-otp-challenge": lazy(() => import("@/screens/mfa-otp-challenge")),
  "mfa-otp-enrollment-code": lazy(
    () => import("@/screens/mfa-otp-enrollment-code")
  ),
  "mfa-otp-enrollment-qr": lazy(
    () => import("@/screens/mfa-otp-enrollment-qr")
  ),
  "mfa-phone-enrollment": lazy(() => import("@/screens/mfa-phone-enrollment")),
  "mfa-recovery-code-challenge": lazy(
    () => import("@/screens/mfa-recovery-code-challenge")
  ),
  "mfa-recovery-code-challenge-new-code": lazy(
    () => import("@/screens/mfa-recovery-code-challenge-new-code")
  ),
  "mfa-recovery-code-enrollment": lazy(
    () => import("@/screens/mfa-recovery-code-enrollment")
  ),
  "mfa-sms-challenge": lazy(() => import("@/screens/mfa-sms-challenge")),
  "mfa-sms-enrollment": lazy(() => import("@/screens/mfa-sms-enrollment")),
  "passkey-enrollment": lazy(() => import("@/screens/passkey-enrollment")),
  "reset-password": lazy(() => import("@/screens/reset-password")),
  "reset-password-email": lazy(() => import("@/screens/reset-password-email")),
  "reset-password-error": lazy(() => import("@/screens/reset-password-error")),
  "reset-password-request": lazy(
    () => import("@/screens/reset-password-request")
  ),
  "reset-password-success": lazy(
    () => import("@/screens/reset-password-success")
  ),
  "signup-id": lazy(() => import("@/screens/signup-id")),
  "signup-password": lazy(() => import("@/screens/signup-password")),
};

export const getScreenComponent = (
  screenName: string | undefined
): React.ComponentType | null => {
  if (!screenName) {
    return null;
  }
  return SCREEN_COMPONENTS[screenName] || null;
};
